import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ViewSolutionScreen from "./Components/ViewSolutionScreen";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";

type Props = {
  rows: any[];
  onAddNew: () => void;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const AssignmentListing = ({
  rows,
  onAddNew,

  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <div className="flex flex-col h-full">
      {/* Page Header */}
      <div className="p-4">
        <ATMPageHeader
          pageTitle="Assignments"
          hideAddButton={
            !isCheckActionsPermission({
              moduleName: UserModuleNameTypes.BATCHES,
              actionName: UserModuleActionTypes.BATCHES_ASSIGNMENTS_ADD,
            })
          }
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          buttonProps={{
            btnName: "Add New",
            onClick: onAddNew,
          }}
        />
      </div>

      {/* Table */}
      {isTableLoading ? (
        <div>
          {Array(4)
            .fill(0)
            .map((_, index) => {
              return (
                <div key={index} className="animate-pulse  h-[50px] p-2">
                  <div className="bg-slate-200 h-full rounded"> </div>
                </div>
              );
            })}{" "}
        </div>
      ) : (
        //LIST DATA
        rows?.map((el: any, ind: any) => {
          return (
            <div className="m-1" key={ind}>
              <ViewSolutionScreen
                totalStudent={el?.totalStudents}
                doneByStudents={el?.totalStudentDoneAssignment}
                questionLabel={el?.questionLabel}
                questionId={el?.questionId} 
                assignmentId={el?._id}
                batchId={el?.batchId}
                title={el?.questionTitle}
                studentAvailable={el?.assignment?.map((el: any) =>
                  el?.studentLabel === null ? false : true
                )}
                assignment={el?.assignment}
              />
            </div>
          );
        })
      )}

      <div className="p-4 py-2 flex justify-end">
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default AssignmentListing;
